<div class="page-header">
    <div class="row hidden-lg hidden-md">
        <div class="text-center center-block col">
            <img style="margin: 0 auto; padding-left: 100px;" src="assets/img/logo.png"
                class="img-responsive col text-center">
        </div>
    </div>
    <div class="row">
        <div class="col-md-2 col-lg-2 hidden-sm hidden-xs center-block">
            <img style="margin: 0 auto; padding-left: 100px; " src="assets/img/logo.png" class="img-responsive">
            @if(isDevEnvironment) {
            <span class="test-mode">TEST</span>
            }
        </div>

        <div *ngIf='globalData.isUserLogged'>

            <div class="col-md-8 col-lg-8 col" style="margin: 0 auto; margin-bottom: 1%; padding-top: 1.5%;">

                <a *ngIf="(globalData.isAdminLogged && !globalData.isRivenditoreServizi) || globalData.isBagninoLogged "
                    routerLink="/gest-ombrelloni" skipLocationChange=false routerLinkActive="active"
                    class="btn btn-header btn-default ">Gestione
                    Ombrelloni</a>
                <a *ngIf="(globalData.isAdminLogged && !globalData.isRivenditoreServizi) || globalData.isBagninoLogged "
                    routerLink="/gest-abbonamenti" skipLocationChange=false routerLinkActive="active"
                    class="btn btn-header btn-default "> Abbonamenti</a>
                <a *ngIf="globalData.isAdminLogged || globalData.isGestoreBarLogged" routerLink="/gest-lista-piatti"
                    skipLocationChange=false routerLinkActive="active" class="btn btn-header btn-default   ">Gestione
                    Menu</a>
                <a *ngIf="(globalData.isAdminLogged || globalData.isGestoreBarLogged || globalData.isRivenditoreServizi)"
                    routerLink="/gest-ristorante" skipLocationChange=false routerLinkActive="active"
                    class="btn btn-header btn-default   ">Gestione
                    Ristorante</a>
                <a *ngIf="(globalData.isAdminLogged || globalData.isGestoreBarLogged) && !globalData.isRivenditoreServizi"
                    routerLink="/gest-ordini-bar" skipLocationChange=false routerLinkActive="active"
                    class="btn btn-header btn-default   ">Ordini Bar e Servizi</a>
                <a *ngIf="globalData.isAdminLogged && !globalData.isRivenditoreServizi" routerLink="/anagrafica-clienti"
                    skipLocationChange=false routerLinkActive="active" class="btn btn-header btn-default ">Gestione
                    Clienti</a>
                <a *ngIf="globalData.isSuperAdmin && !globalData.isRivenditoreServizi"
                    routerLink="/anagrafica-rivenditori" skipLocationChange=false routerLinkActive="active"
                    class="btn btn-header btn-default ">Gestione
                    Rivenditori</a>
                <a *ngIf="(globalData.isAdminLogged || globalData.isGestoreBarLogged) && !globalData.isRivenditoreServizi"
                    routerLink="/gest-magazzino" skipLocationChange=false routerLinkActive="active"
                    class="btn btn-header btn-default  ">Servizi Spiaggia</a>
                <a *ngIf="(globalData.isAdminLogged && !globalData.isRivenditoreServizi) ||  globalData.isBagninoLogged "
                    routerLink="/storico-ordini-completo" skipLocationChange=false routerLinkActive="active"
                    class="btn btn-header btn-default ">Ordini
                    Ombrelloni</a>
                <a *ngIf="(globalData.isAdminLogged || globalData.isGestoreBarLogged) && !globalData.isRivenditoreServizi"
                    routerLink="/news-page" skipLocationChange=false routerLinkActive="active"
                    class="btn btn-header btn-default ">Gestisci News</a>
                <a *ngIf="(globalData.isSuperAdmin) && !globalData.isRivenditoreServizi" routerLink="/rivenditori"
                    skipLocationChange=false routerLinkActive="active" class="btn btn-header btn-default ">Incassi
                    Rivenditori</a>
                <!--   <a *ngIf="globalData.isSuperAdmin" routerLink="/riepilogo-incassi" skipLocationChange=false
                    routerLinkActive="active" class="btn btn-header btn-default ">Report Incassi</a>
 -->
                <!-- SEZIONE PER UTENTI-RIVENDITORI SERVIZI -->

                <a *ngIf="globalData.isRivenditoreServizi" routerLink="/gest-ombrelloni-esercizi"
                    skipLocationChange=false routerLinkActive="active" class="btn btn-header btn-default "> Ombrelloni
                    Rivenditore</a>
                <a *ngIf="globalData.isRivenditoreServizi" routerLink="/gest-abbonamenti-esercizi"
                    skipLocationChange=false routerLinkActive="active" class="btn btn-header btn-default "> Abbonamenti
                    Rivenditore</a>
            </div>
            <div class="col-md-2 col-lg-2"
                *ngIf="(globalData.fotoProfilo == '' || globalData.fotoProfilo == null || globalData.fotoProfilo == undefined)">
                <a routerLink="/profilo" skipLocationChange=false><img style="min-width: 70px; margin: 0 auto;"
                        src="./assets/img/profilo.png" class="img-responsive foto-profilo"></a>
                <p class="text-center">Ciao {{globalData.datiUtente.nome}}!</p>
                <a style="display: block; text-align: center;" (click)="globalData.logout()">Logout</a>
            </div>

            <div class="text-center col-md-2 col-lg-2"
                *ngIf="!(globalData.fotoProfilo == '' || globalData.fotoProfilo == null || globalData.fotoProfilo == undefined)">
                <a routerLink="/profilo" skipLocationChange=false><img
                        style="border-radius: 50%; min-width: 70px; margin: 0 auto;" src="{{globalData.fotoProfilo}}"
                        class=" img-responsive foto-profilo"></a>
                <p class="text-center">Ciao {{globalData.datiUtente.nome}}!</p>
                <a style="display: block; text-align: center;" (click)="globalData.logout()">Logout</a>
            </div>
        </div>
    </div>
</div>